import { Dialog } from "primereact/dialog";
import { JVDate } from "../../shared/JVDate";
import { JVInput } from "../../shared/JVInput";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { useForm } from "react-hook-form";
import { ITimesheet } from "../../models/Timesheet";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";
import { JVDropdown } from "../../shared/JVDropdown";
import { POStatus } from "../../models/PurchaseOrder";
import { POStatusMap } from "../../models/FDropdown";

interface IProps {
  singleData: any;
  data: any;
  open: boolean;
  hideDialog: () => void;
  toast: any;
  loadTableData: () => void;
}

const schema = yup.object({
  fromDate: yup
    .date()
    .required("From Date is required")
    .typeError("From Date is required"),
  toDate: yup
    .date()
    .required("To Date is required")
    .typeError("To Date is required"),
  workHours: yup
    .number()
    .max(90, "Maximum 90 hours allowed")
    .required("Work Hours is required")
    .typeError("Work Hours is required"),
  overlapWorkHours: yup
    .number()
    .max(90, "Maximum 90 hours allowed")
    .nullable()
    .typeError("Work Hours must be a number"),
  timeSheet_Path: yup.string().required("TimesSheet is required"),
  comments: yup.string().nullable(),
  isNotWorking: yup.boolean().nullable(),
  timeSheet_Status: yup.boolean().nullable(),
});

export const Form = (props: IProps) => {
  const [loading, setLoading] = useState(false);
  const [fileUploaded, setFileUploaded] = useState(false);
  const [workHoursHeader, setWorkHoursHeader] = useState<string>("Work Hours");
  const [overlapHoursHeader, setOverlapHoursHeader] =
    useState<string>("Overlaping Hours");
  const [disableAllField, setDisableAllField] = useState<boolean>(false);
  const [showOverlap, setShowOverlap] = useState<boolean>(false);
  const [showComment, setShowComment] = useState<boolean>(false);
  const [timesheetFile, setTimesheetFile] = useState<File | null | any>(null);

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm<ITimesheet>({
    resolver: yupResolver(schema),
    defaultValues: {},
    shouldFocusError: false,
  });

  const fileUploade = (event: FileUploadHandlerParam) => {
    if (event.files[0].size >= 1024 * 1024 * 5) {
      props.toast.current.show({
        severity: "error",
        content: "Document should be less than 5 MB.",
      });
      event.options.clear();
    } else {
      props.toast.current.show({
        severity: "success",
        content: "A Document Selected.",
      });
      setTimesheetFile(event.files[0]);
      //   uploadeFile(event.files[0]);
      setFileUploaded(true);
      event.options.clear();
    }
  };

  const uploadeFile = async (file: File) => {
    setLoading(true);
    let formData = new FormData();
    formData.append("file", file);

    const params = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token
          }`,
      },
      body: formData,
    };
    const response = await fetch(`${baseUrl}Ticket/file`, params);
    if (response.ok) {
      const data = await response.text();
      setValue("timeSheet_Path", data);
      props.toast.current.show({
        severity: "success",
        content: `Document Uploaded Successfully as -"${data}"`,
      });
      setFileUploaded((prev) => (prev = true));
    }
    setLoading(false);
  };

  const onSubmit = (data: ITimesheet) => {
    // data.consultant_ID = props.singleData.consultant_ID;
    // data.pO_ID = props.singleData.pO_ID;
    if (
      new Date(data.toDate || "").getFullYear() > new Date().getFullYear() ||
      (new Date(data.toDate || "").getMonth() > new Date().getMonth() && new Date(data.toDate || "").getFullYear() === new Date().getFullYear()) ||
      (new Date(data.toDate || "").getMonth() === new Date().getMonth() &&
        new Date(data.toDate || "").getDate() > new Date().getDate())
    ) {
      props.toast.current.show({
        severity: "error",
        content: `Week not ended yet`,
      });
    } else if (
      fileUploaded === false &&
      disableAllField === false &&
      !(props.data.timesheet_ID !== null && props.data.timesheet_ID !== 0)
    ) {
      props.toast.current.show({
        severity: "error",
        content: `Uploaded Document First`,
      });
    } else {
      if (
        showOverlap === true &&
        data?.overlapWorkHours &&
        data?.overlapWorkHours === 0
      ) {
        props.toast.current.show({
          severity: "error",
          content: `Please Enter Overlap Hours`,
        });
      } else {
        if (
          Number(data?.workHours || "0") +
          Number(data?.overlapWorkHours || "0") >=
          91
        ) {
          props.toast.current.show({
            severity: "error",
            content: `Working Hours can not be greater than 90`,
          });
        } else saveToDB(data);
      }
    }
  };

  const saveToDB = async (data: ITimesheet) => {
    let body: any = data;
    body.pO_ID = props.data.pO_Id;
    body.consultant_ID = props.data.consultant_ID;
    if (props.data.timesheet_ID !== null && props.data.timesheet_ID !== 0) {
      body.timesheet_ID = props.data.timesheet_ID;
    }
    // let formData = new FormData();
    // formData.append("file", timesheetFile);

    if (!Number(data.workHours) && disableAllField === false) {
      props.toast.current.show({
        severity: "error",
        detail: "Working Hours Must Be In Numbers",
        life: 3000,
      });
    } else {
      body.workHours = Number(data.workHours);

      setLoading(true);
      const method =
        props.data.timesheet_ID !== null && props.data.timesheet_ID !== 0
          ? "PUT"
          : "POST";
      const message = props.singleData.timesheet_ID
        ? "Updated Successfully"
        : "Added Successfully";

      const formData = new FormData();

      if (timesheetFile) {
        formData.append("file", timesheetFile);
      }

      formData.append("newTimesheet", JSON.stringify(body));

      // const response = await Fetch(
      //   "Timesheet",
      //   method,
      //   body,
      //   null,
      //   props.toast,
      // );
      // if (response) {
      //   props.loadTableData();
      //   props.hideDialog();
      //   props.toast.current.show({
      //     severity: "success",
      //     detail: message,
      //     life: 3000,
      //   });
      // }
      const params = {
        method: method,
        headers: {
          'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
        },
        body: formData
      };
      const response = await fetch(`${baseUrl}Timesheet`, params);
      if (response.ok) {
        // setDisableAllField(prev => prev = false);
        // onHide();
        props.loadTableData();
        props.hideDialog();
        props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
      } else {
        if (response.status === 400) {
          const message = await response.text();
          props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
        } else {
          props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
      }
      setLoading(false);
    }
  };

  const onHide = () => {
    //  setTimesheetFile(null);
    setWorkHoursHeader("Work Hours");
    setOverlapHoursHeader("Overlaping Hours");
    setShowOverlap(false);
    props.hideDialog();
    reset();
  };

  const poDate = (rowData: any) => {
    let date;
    if (rowData.pO_Date)
      date = format(new Date(rowData.pO_Date), "dd/MM/yyyy").toUpperCase();
    else date = "";
    return <>{date}</>;
  };

  const startDate = (rowData: any) => {
    let date;
    if (rowData.project_Start_Date)
      date = format(
        new Date(rowData.project_Start_Date),
        "dd/MM/yyyy",
      ).toUpperCase();
    else date = "";
    return <>{date}</>;
  };
  const endDate = (rowData: any) => {
    let date;
    if (rowData.project_End_Date)
      date = format(
        new Date(rowData.project_End_Date),
        "dd/MM/yyyy",
      ).toUpperCase();
    else date = "";
    return <>{date}</>;
  };

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (name === "fromDate") {
        if (value.fromDate != null) {
          const dayOfWeek = value.fromDate.getDay();
          if (dayOfWeek === 0) {
            setValue("toDate", value.fromDate);

            setWorkHoursHeader("Work Hours");
            setOverlapHoursHeader("Overlaping Hours");
            setValue("overlapWorkHours", 0);
            setShowOverlap(false);
          } else {
            setValue(
              "toDate",
              new Date(
                new Date(value.fromDate).setDate(
                  new Date(value.fromDate).getDate() + (6 - dayOfWeek + 1),
                ),
              ),
            );

            const toDateIs: Date = new Date(
              new Date(value.fromDate).setDate(
                new Date(value.fromDate).getDate() + (6 - dayOfWeek + 1),
              ),
            );

            if (
              new Date(value.fromDate || "").getMonth() + 1 !==
              new Date(toDateIs || "").getMonth() + 1
            ) {
              setShowOverlap(true);
              const lastDateOfFrom = new Date(
                new Date(value.fromDate || "").getFullYear(),
                new Date(value.fromDate || "").getMonth() + 1,
                0,
              );
              const firstDateOfTo = new Date(
                new Date(toDateIs || "").getFullYear(),
                new Date(toDateIs || "").getMonth(),
                1,
              );
              setWorkHoursHeader(
                `Work Hours : (${new Date(value.fromDate || "").getDate()}-${new Date(value.fromDate || "").getMonth() + 1
                }-${new Date(
                  value.fromDate || "",
                ).getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1
                }-${lastDateOfFrom.getFullYear()})`,
              );
              setOverlapHoursHeader(
                `Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1
                }-${firstDateOfTo.getFullYear()}) to (${new Date(
                  toDateIs || "",
                ).getDate()}-${new Date(toDateIs || "").getMonth() + 1
                }-${new Date(toDateIs || "").getFullYear()})`,
              );
            }

            if (
              props.data.billing_Cycle === true &&
              new Date(value.fromDate || "").getDate() < 16 &&
              new Date(toDateIs || "").getDate() >= 16
            ) {
              setShowOverlap(true);
              const lastDateOfFrom = new Date(
                new Date(value.fromDate || "").getFullYear(),
                new Date(value.fromDate || "").getMonth(),
                15,
              );
              const firstDateOfTo = new Date(
                new Date(toDateIs || "").getFullYear(),
                new Date(toDateIs || "").getMonth(),
                16,
              );
              setWorkHoursHeader(
                `Work Hours : (${new Date(value.fromDate || "").getDate()}-${new Date(value.fromDate || "").getMonth() + 1
                }-${new Date(
                  value.fromDate || "",
                ).getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1
                }-${lastDateOfFrom.getFullYear()})`,
              );
              setOverlapHoursHeader(
                `Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1
                }-${firstDateOfTo.getFullYear()}) to (${new Date(
                  toDateIs || "",
                ).getDate()}-${new Date(toDateIs || "").getMonth() + 1
                }-${new Date(toDateIs || "").getFullYear()})`,
              );
            }

            if (
              new Date(value.fromDate || "").getMonth() + 1 ===
              new Date(toDateIs || "").getMonth() + 1
            ) {
              setWorkHoursHeader("Work Hours");
              setOverlapHoursHeader("Overlaping Hours");
              setValue("overlapWorkHours", 0);
              setShowOverlap(false);
            }
          }
        }
      }
      if (name === "isNotWorking") {
        if (value.isNotWorking != null) {
          if (value.isNotWorking === true) {
            setDisableAllField((prev) => (prev = true));
            setValue("workHours", 0);
            setValue("overlapWorkHours", 0);
            setValue("timeSheet_Path", "null");
            setFileUploaded((prev) => (prev = false));
          } else {
            setDisableAllField((prev) => (prev = false));
          }
        }
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    if (props.open) {
      if (props.data?.timesheet_ID && props.singleData?.isNotWorking === true) {
        setDisableAllField((prev) => (prev = true));
      }

      if (
        !(
          props.data.project_Start_Date !== undefined &&
          props.data.project_Start_Date !== null &&
          (new Date(props.singleData.fromDate || "").getFullYear() <
            new Date(props.data.project_Start_Date || "").getFullYear() ||
            (new Date(props.singleData.fromDate || "").getMonth() <
              new Date(props.data.project_Start_Date || "").getMonth() &&
              new Date(props.singleData.fromDate || "").getFullYear() ===
              new Date(props.data.project_Start_Date || "").getFullYear()) ||
            (new Date(props.singleData.fromDate || "").getMonth() ===
              new Date(props.data.project_Start_Date || "").getMonth() &&
              new Date(props.singleData.fromDate || "").getDate() <
              new Date(props.data.project_Start_Date || "").getDate()))
        ) &&
        new Date(props.singleData?.fromDate || "").getMonth() + 1 !==
        new Date(props.singleData?.toDate || "").getMonth() + 1
      ) {
        setShowOverlap(true);
        const lastDateOfFrom = new Date(
          new Date(props.singleData?.fromDate || "").getFullYear(),
          new Date(props.singleData?.fromDate || "").getMonth() + 1,
          0,
        );
        const firstDateOfTo = new Date(
          new Date(props.singleData?.toDate || "").getFullYear(),
          new Date(props.singleData?.toDate || "").getMonth(),
          1,
        );
        setWorkHoursHeader(
          `Work Hours : (${new Date(
            props.singleData?.fromDate || "",
          ).getDate()}-${new Date(props.singleData?.fromDate || "").getMonth() + 1
          }-${new Date(
            props.singleData?.fromDate || "",
          ).getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1
          }-${lastDateOfFrom.getFullYear()})`,
        );
        setOverlapHoursHeader(
          `Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1
          }-${firstDateOfTo.getFullYear()}) to (${new Date(
            props.singleData?.toDate || "",
          ).getDate()}-${new Date(props.singleData?.toDate || "").getMonth() + 1
          }-${new Date(props.singleData?.toDate || "").getFullYear()})`,
        );
      }

      if (
        !(
          props.data.project_Start_Date !== undefined &&
          props.data.project_Start_Date !== null &&
          (new Date(props.singleData.fromDate || "").getFullYear() <
            new Date(props.data.project_Start_Date || "").getFullYear() ||
            (new Date(props.singleData.fromDate || "").getMonth() <
              new Date(props.data.project_Start_Date || "").getMonth() &&
              new Date(props.singleData.fromDate || "").getFullYear() ===
              new Date(props.data.project_Start_Date || "").getFullYear()) ||
            (new Date(props.singleData.fromDate || "").getMonth() ===
              new Date(props.data.project_Start_Date || "").getMonth() &&
              new Date(props.singleData.fromDate || "").getDate() <
              new Date(props.data.project_Start_Date || "").getDate()))
        ) &&
        props.data.billing_Cycle === true &&
        new Date(props.singleData?.fromDate || "").getDate() < 16 &&
        new Date(props.singleData?.toDate || "").getDate() >= 16
      ) {
        setShowOverlap(true);
        const lastDateOfFrom = new Date(
          new Date(props.singleData?.fromDate || "").getFullYear(),
          new Date(props.singleData?.fromDate || "").getMonth(),
          15,
        );
        const firstDateOfTo = new Date(
          new Date(props.singleData?.toDate || "").getFullYear(),
          new Date(props.singleData?.toDate || "").getMonth(),
          16,
        );
        setWorkHoursHeader(
          `Work Hours : (${new Date(
            props.singleData?.fromDate || "",
          ).getDate()}-${new Date(props.singleData?.fromDate || "").getMonth() + 1
          }-${new Date(
            props.singleData?.fromDate || "",
          ).getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1
          }-${lastDateOfFrom.getFullYear()})`,
        );
        setOverlapHoursHeader(
          `Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1
          }-${firstDateOfTo.getFullYear()}) to (${new Date(
            props.singleData?.toDate || "",
          ).getDate()}-${new Date(props.singleData?.toDate || "").getMonth() + 1
          }-${new Date(props.singleData?.toDate || "").getFullYear()})`,
        );
      }

      if (
        props.singleData.comments &&
        props.singleData.comments.trim() !== ""
      ) {
        setShowComment(true);
      }

      const fromDate =
        props.data.project_Start_Date !== undefined &&
          props.data.project_Start_Date !== null &&
          (new Date(props.singleData.fromDate || "").getFullYear() <
            new Date(props.data.project_Start_Date || "").getFullYear() ||
            (new Date(props.singleData.fromDate || "").getMonth() <
              new Date(props.data.project_Start_Date || "").getMonth() &&
              new Date(props.singleData.fromDate || "").getFullYear() ===
              new Date(props.data.project_Start_Date || "").getFullYear()) ||
            (new Date(props.singleData.fromDate || "").getMonth() ===
              new Date(props.data.project_Start_Date || "").getMonth() &&
              new Date(props.singleData.fromDate || "").getDate() <
              new Date(props.data.project_Start_Date || "").getDate()))
          ? new Date(props.data.project_Start_Date || "")
          : new Date(props.singleData.fromDate || "");

      const workHours =
        Number(props.singleData.workHours || "0") +
        Number(props.singleData.overlapWorkHours || "0");

      reset({
        ...props.singleData,
        fromDate: fromDate,
        workHours:
          fromDate.getMonth() ===
            new Date(props.singleData?.toDate || "").getMonth()
            ? workHours
            : props.singleData.workHours,
      });
    }
  }, [props.open]);

  return (
    <Dialog
      visible={props.open}
      style={{ width: "80vw" }}
      header="Add/Update Consultant TimeSheet"
      modal
      className="p-fluid"
      onHide={onHide}
    >
      <DataTable
        style={{
          border: "1px solid rgba(105,105,105,0.17)",
          borderTopWidth: "0",
        }}
        stripedRows
        showGridlines
        size="small"
        value={[props.data]}
      >
        <Column field="consultant_Name" header="Consultant" />
        <Column field="project_Client_Name" header="End Client" />
        <Column field="vendor_Company_Name" header="Vendor Company Name" />
        <Column field="sub_Vendor_Company" header="Sub Vendor Company" />
        <Column field="pO_Date" header="PO Date" body={poDate} />
        <Column
          field="project_Start_Date"
          header="Project Start Date"
          body={startDate}
        />
        <Column
          field="project_End_Date"
          header="Project End Date"
          body={endDate}
        />
        <Column field="pO_Status" header="PO Status" body={r => r.pO_Status ? POStatusMap[r.pO_Status] : ''} />
      </DataTable>
      <div style={{ marginTop: "25px", width: "100%" }}></div>
      <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
        <JVDate
          required
          column={3}
          label="From Date"
          maxDate={new Date()}
          disabled
          control={control}
          name="fromDate"
          error={errors.fromDate?.message}
        />
        <JVDate
          required
          column={3}
          label="To Date"
          maxDate={new Date()}
          disabled
          control={control}
          name="toDate"
          error={errors.toDate?.message}
        />
        <JVInput
          required
          column={3}
          label={workHoursHeader}
          disabled={disableAllField}
          control={control}
          name="workHours"
          error={errors.workHours?.message}
        />
        {showOverlap && (
          <JVInput
            required
            column={3}
            label={overlapHoursHeader}
            disabled={disableAllField && showOverlap}
            control={control}
            name="overlapWorkHours"
            error={errors.overlapWorkHours?.message}
          />
        )}
        <JVDropdown
          column={3}
          label="Status"
          control={control}
          name="timeSheet_Status"
          error={errors.timeSheet_Status?.message}
          options={[
            { name: "--SELECT--", value: null },
            { name: "verified", value: true },
            { name: "Rejected", value: false },
          ]}
          optionLabel="name"
          optionValue="value"
          placeholder="Select Timesheet Status"
        />
        <div className="field col-12 md:col-2">
          <label htmlFor="file">
            TimeSheet<span style={{ color: "red" }}>*</span>
          </label>
          <FileUpload
            disabled={disableAllField}
            chooseLabel="Choose File"
            mode="basic"
            name="file"
            accept="*"
            maxFileSize={10000000}
            customUpload
            auto
            uploadHandler={fileUploade}
          />
          {errors.timeSheet_Path?.message && (
            <small className="p-error">{errors.timeSheet_Path?.message}</small>
          )}
        </div>
        <div className="field col-12 md:col-3 pt-5">
          <JVCheckbox
            column={1}
            label="Not Worked"
            control={control}
            name="isNotWorking"
          />
        </div>
        {showComment && (
          <JVInput
            column={2}
            label="Comment"
            control={control}
            name="comments"
            error={errors.comments?.message}
          />
        )}

        <div
          className="col-12 md:col-12"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            columnGap: "10px",
            marginTop: "10px",
          }}
        >
          <Button
            className="field col-12 md:col-6  h-2rem"
            label="SAVE"
            type="submit"
            loading={loading}
          ></Button>
          <Button
            className="field col-12 md:col-6 p-button-outlined  h-2rem"
            label="CLOSE"
            onClick={onHide}
            type="button"
          ></Button>
        </div>
      </form>
    </Dialog>
  );
};
